import { useCallback, useContext, useEffect } from "react";
import { UserUIStateContext } from "../store/userUIStateContext";
import { E2Data } from "../lib/ddd/ddd";
import { OrgIdContext } from "../store/orgId_context";
import { useQuery } from "@tanstack/react-query";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const dataTable = new E2Data("EU_UI_AdminTransfomer");

const useUserUIState = () => {
    const { mainOrgId } = useContext(OrgIdContext);
    const {loadServerData, getAllSettingsObject} = useContext(UserUIStateContext);

    const {isPending , data } = useQuery({
        queryKey: ['Data.GetEntityData', dataTable.GetParamsObject()],
        queryFn: () => dataTable.GetData(),
        cacheTime : 0
    });

    const generateUIData = useCallback(() =>{
        if(!mainOrgId)
            return console.error("Unable to generate UI data. Missing main org id");
        const uiObj = getAllSettingsObject();
        let data = {
            UI_Variables : JSON.stringify(uiObj),
            Organization : mainOrgId
        }
        
        dataTable.values = data;
        dataTable.Create();
    }, [mainOrgId, getAllSettingsObject]);

    useEffect(() =>{ 
        if(isPending || !data)
            return;
        
        let _data = data?.result?.data;
        if(!_data)
            return console.error("Data response issue");
        if(_data.length === 0){
            generateUIData();
        }else{
            let uiString = _data[0].UI_Variables || "{}";
            let rowId = _data[0].Id;
            let uiObj = {};
            try{
                uiObj = JSON.parse(uiString);
            }catch{
                uiObj = {};
            }
            loadServerData(uiObj, rowId)
        }
        
    },[isPending, mainOrgId]);
}

export default useUserUIState;